import { colors } from "./colors";

export const options: object = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (tooltipItem, data) {
          return (
            tooltipItem.label +
            ": " +
            tooltipItem.parsed +
            "%"
          );
        },
      },
    },
  },
};

export const defaultData = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: colors,
      borderColor: colors,
    },
  ],
};
